module.exports = __webpack_public_path__ + "static/power4-1-5804233de3944be6a8ad2aa788f1cd39.png";